// extracted by mini-css-extract-plugin
export default {"wrongPartnerWrapper":"WrongPartner-module_wrongPartnerWrapper__D55vB","wrongPartnerMessage":"WrongPartner-module_wrongPartnerMessage__Nk3eD"};